module.exports = __webpack_public_path__ + "static/charts-dribbble-909a62d4fef98b96e5f11715c9bb1af8.gif";